import { useCallback, useMemo } from 'react'
import { generatePath, useHistory } from 'react-router-dom'
import { mdiAlert, mdiCheck } from '@mdi/js'
import Icon from '@mdi/react'
import { useIntl } from 'react-intl'
import { useNetworkHomeJobsRouteParams } from 'features/networkAi/hooks'
import getDeclensionLabel from 'app/utils/getDeclensionLabel'
import theme from 'theme_'
import ROUTES from 'app/routes'
import {
  SubscriptionStatusButton,
  SubscriptionStatusInformationContainer,
  SubscriptionStatusInformationText,
} from '../styles'
import { purchaseSubscriptionMessages } from '../../PurchaseDeviceSubscription/messages'

interface SubsriptionStatusInformationProps {
  showClaimDeviceButton: boolean
  claimedCount: number
  subscribedCount: number
}

function SubsriptionStatusInformation({
  showClaimDeviceButton,
  claimedCount,
  subscribedCount,
}: SubsriptionStatusInformationProps) {
  const history = useHistory()
  const { rootDomainId, homeId, jobId } = useNetworkHomeJobsRouteParams()
  const { formatMessage } = useIntl()

  const unclaimedCount = useMemo(
    () => subscribedCount - claimedCount,
    [claimedCount, subscribedCount]
  )

  const handleClickToClaimDevice = useCallback(() => {
    const path = generatePath(ROUTES.networkAi.wizard.claimDevice, {
      rootDomainId,
      jobId,
      homeId,
    })

    history.push(path)
  }, [history, homeId, jobId, rootDomainId])

  const claimedDeviceLabel = useMemo(() => {
    return getDeclensionLabel(claimedCount, 'device')
  }, [claimedCount])

  const subscriptionLabel = useMemo(() => {
    return getDeclensionLabel(subscribedCount, 'subscription')
  }, [subscribedCount])

  return (
    <SubscriptionStatusInformationContainer isSuccess={!showClaimDeviceButton}>
      {showClaimDeviceButton ? (
        <>
          <Icon path={mdiAlert} size={0.8} color={theme.colors.error} />
          <SubscriptionStatusInformationText>
            {unclaimedCount}{' '}
            {formatMessage(purchaseSubscriptionMessages.claimMessage)}
          </SubscriptionStatusInformationText>
          <SubscriptionStatusButton
            variant="primary"
            onClick={handleClickToClaimDevice}
          >
            {formatMessage(purchaseSubscriptionMessages.claimDevices)}
          </SubscriptionStatusButton>
        </>
      ) : (
        <>
          <Icon path={mdiCheck} size={0.8} color={theme.colors.success} />
          <SubscriptionStatusInformationText>
            Success. You have claimed {claimedCount} {claimedDeviceLabel} for{' '}
            {subscribedCount} {subscriptionLabel}.
          </SubscriptionStatusInformationText>
        </>
      )}
    </SubscriptionStatusInformationContainer>
  )
}

export default SubsriptionStatusInformation
